import { createContext } from "react";
import type { UserRegionInfo } from "@/lib/userRegion";

export interface UserRegionContextType {
  regionInfo: UserRegionInfo;
  currentTime: string;
  currentDate: string;
  requestPreciseLocation: () => Promise<void>;
  updateRegion: (info: Partial<UserRegionInfo>) => void;
}

export const UserRegionContext = createContext<UserRegionContextType | undefined>(undefined);
